import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { authenticatedUserSchema } from '../../../schemas/authenticated-user.schema';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Checks to see if the user is already authenticated via SSO
 * @param product Trimble Maps Product
 * @returns Authenticated User
 */
export function postVerify(this: unknown, product: string) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).securityVerifyUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      credentials: 'include',
      body: JSON.stringify({ product }),
    })
  ).pipe(selectData(authenticatedUserSchema));
}
